<template>
  <div>
    <param-card
      linkTo="paikkakunta"
      :iconUrl="require('../assets/param/common_location.png')"
      :label="'house.param.town.title' | i18n"
      :value="townName" />

    <param-card
      linkTo="pohjamuoto"
      :iconUrl="floorShapeIcon"
      :label="'house.param.floorShape.title' | i18n"
      :value="floorShapeLabel" />

    <param-card
      linkTo="kerrokset"
      :iconUrl="floorsIcon"
      :label="'house.param.floors.title' | i18n"
      :value="includedFloorsStr" />

    <param-card
      linkTo="asuinkerros"
      :iconUrl="require('../assets/param/house_living_floor.png')"
      :label="'house.param.livingFloor.title' | i18n"
      :value="livingFloorStr" />

    <param-card
      linkTo="kattomuoto"
      :iconUrl="roofShapeIcon"
      :label="'house.param.roofShape.title' | i18n"
      :value="roofShapeLabel" />

    <param-card
      linkTo="ovet"
      :iconUrl="require('../assets/param/house_doors.jpg')"
      :label="'house.param.doors.title' | i18n"
      :value="numOfDoors"
      unit="kpl" />

    <param-card
      linkTo="ikkunat"
      :iconUrl="require('../assets/param/house_windows.png')"
      :label="'house.param.windows.title' | i18n"
      :value="numOfWindowsStr" />

    <param-card
      linkTo="tulisijat"
      :iconUrl="require('../assets/param/house_fireplaces.png')"
      :label="'house.param.fireplaces.title' | i18n"
      :value="numOfFireplaces"
      unit="kpl"/>
  </div>
</template>


<script>
  import Vue from 'vue'
  import { mapState, mapActions, mapGetters } from 'vuex'
  import ParamCard from './ParamCard'
  import { roomShapes, defaultRoofShape, defaultRoomShape } from "../api/constants";

  export default {
    computed: {
      ...mapState('houseParams', {
        shape: state => state.shape,

        numOfDoors: state => state.numOfDoors,
        numOfFireplaces: state => state.numOfFireplaces,

        floorShapeLabel: state => state.shape != null ? state.shape.label : null,
        floorShapeIcon: state => state.shape != null ? state.shape.icon : defaultRoomShape.icon,

        roofShapeLabel: state => state.roofShape != null ? state.roofShape.label : null,
        roofShapeIcon: state => state.roofShape != null ? state.roofShape.icon : defaultRoofShape.icon,

        townName: state => (state.town != null ? (state.town.stateName + '|' + state.town.name) : null),

        floorsIcon(state, getters) {
          if(getters.includedFloorsStr != null) {
            let floors = (state.upstairsIncluded ? 'yk-' : '') + 'ak' + (state.basementIncluded ? '-k' : '')
            return require(`../assets/kerrosluku/kerrokset-${floors}.png`)
          }
          return require('../assets/param/house_floors.png')
        },
      }),

      ...mapGetters('houseParams', [
        'includedFloorsStr',
        'numOfWindowsStr',
        'livingFloorStr'
      ])
    },

    components: {
      ParamCard
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HouseParams.vue